/* Handling of pre-screening related state */
import {
  LIST_PRE_SCREENING_STEPS_SUCCESS,
  STORE_PRE_SCREENING_APPLICATION
} from '@stores/mutation-types';

import {
  Prescreening
} from '@services/App/prescreening';

const state = () => ({
  steps: [],
  responses: {
    store: []
  }
});

const mutations = {

  [LIST_PRE_SCREENING_STEPS_SUCCESS]: (state, payload) => {
    state.steps = payload;
  },

  [STORE_PRE_SCREENING_APPLICATION]: (state, payload) => {
    state.responses.store = payload;
  }

};

const actions = {

  /**
   * Archive team
   *
   * @param {object} context Vuex context keys
   * @param {string} parameters
   *
   * @return {promise}
   */
  async listPrescreeningSteps({ commit, state }, params) {
    const response = await Prescreening.listPrescreeningSteps(
      params,
      params.missionId
    );

    if (response.success) {
      commit(LIST_PRE_SCREENING_STEPS_SUCCESS, response.data);
    }

    return state.steps;
  },

  storeUserResponse({ commit, state }, params) {
    localStorage.setItem('preScreeningQuestionnaire', JSON.stringify(params));

    return true;
  },

  async storeApplication({ commit, state }, params) {
    const response = await Prescreening.storeApplication(
      params,
      params.missionId
    );

    if (response.success) {
      commit(STORE_PRE_SCREENING_APPLICATION, response.data);
    }

    return response;
  }

};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
